import React, { useContext } from "react";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import OrderMap from "./OrderMap";
import ConfirmModal from "../modal/ConfirmModal";
import { StoreContext } from "../../../../store/index";
import { StoreContext as OldStoreContext } from "../../../../../store/Provider";
import moment from "moment";
import { path } from "../../../../constants/apiPath";
import instance from "../../../../common/api/interceptor";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";
// import routeConstant from "../../../../routes/utils/routeConstant";
import orderObject from "../../../../constants/data/orderCreation";
import routeConstant from "../../../../../route/compoent/routeConstant";
import { OrderContext } from "../../../orderList/store";
import { userRole } from "../../../../utils/utility";

function Confirmation() {
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);
  const location = useLocation();
  const navigate = useNavigate();

  const { setPlacedData, placedData } = useContext(OrderContext);

  const onNextHandler = (path) => {
    const body = JSON.parse(JSON.stringify(context.orderJSON));

    context.orderJSON.OrderLinesCollection.map((ele, index) => {
      console.log(ele);

      body.OrderLinesCollection[index].LineIndex = index;
      body.OrderLinesCollection[index].LineIncoTerms = ele.LineIncoTerms.Code;
      body.OrderLinesCollection[index].UnitOfQuantity = ele.UnitOfQuantity.Unit;

      body.OrderLinesCollection[index].LineOuterPacksUnit =
        ele.LineOuterPacksUnit.Code;
      body.OrderLinesCollection[index].LineInnerPacksUnit =
        ele.LineInnerPacksUnit.Code;

      body.OrderLinesCollection[index].UnitOfDimension =
        ele.UnitOfDimension.Unit;
      body.OrderLinesCollection[index].LineUnitOfWeight =
        ele.LineUnitOfWeight.Unit;
      body.OrderLinesCollection[index].LineUnitOfVolume =
        ele.LineUnitOfVolume.Unit;
      body.OrderLinesCollection[index].LineReqInStoreDate =
        ele.LineReqInStoreDate
          ? moment(ele.LineReqInStoreDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderLinesCollection[index].LineConfirmDate = ele.LineConfirmDate
        ? moment(ele.LineConfirmDate).format("YYYY-MM-DD HH:mm:ss")
        : "";
    });

    context.orderJSON.OrderPlanningCollection.map((ele, index) => {
      body.OrderPlanningCollection[index].PlanningIndex = index;
      body.OrderPlanningCollection[index].PlanningOriginCountryName =
        ele.PlanningOriginCountryName.Description;
      body.OrderPlanningCollection[index].PlanningOriginCountryCode =
        ele.PlanningOriginCountryName.Code;

      body.OrderPlanningCollection[index].PlanningDestinationCountryName =
        ele.PlanningDestinationCountryName.Description;
      body.OrderPlanningCollection[index].PlanningDestinationCountryCode =
        ele.PlanningDestinationCountryName.Code;

      body.OrderPlanningCollection[index].PlanningOriginPortCode =
        ele.PlanningOriginPortName.Code;
      body.OrderPlanningCollection[index].PlanningOriginPortName =
        ele.PlanningOriginPortName.PortName;

      body.OrderPlanningCollection[index].PlanningDestinationPortCode =
        ele.PlanningDestinationPortName.Code;
      body.OrderPlanningCollection[index].PlanningDestinationPortName =
        ele.PlanningDestinationPortName.PortName;

      body.OrderPlanningCollection[index].PlanningSendingAgentPK =
        ele.PlanningSendingAgentCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningSendingAgentCode =
        ele.PlanningSendingAgentCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningReceivingAgentPK =
        ele.PlanningReceivingAgentCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningReceivingAgentCode =
        ele.PlanningReceivingAgentCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningCarrierPK =
        ele.PlanningCarrierCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningCarrierCode =
        ele.PlanningCarrierCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningCutOfDate =
        ele.PlanningCutOfDate
          ? moment(ele.PlanningCutOfDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningEstimatedDepart =
        ele.PlanningEstimatedDepart
          ? moment(ele.PlanningEstimatedDepart).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningEstimatedArrival =
        ele.PlanningEstimatedArrival
          ? moment(ele.PlanningEstimatedArrival).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningForwarderCarrier =
        ele.PlanningForwarderCarrier.value ?? "";

      body.OrderPlanningCollection[index].PlanningFinalDestination =
        ele.PlanningFinalDestination.Description;
      // body.OrderPlanningCollection[index].PlanningRates = ele.PlanningRates;
      body.OrderPlanningCollection[index].OrderPlanningContainerCollection = [];
    });

    console.log("body in confirm", { body });

    onPostOrder(path, body);
  };

  const onPostOrder = (route, body) => {
    const roles = oldContext.omsUserData.UserRoles;
    context.setBackDropOpen(true);
    instance
      .post(`${path.EDIT_POST_ORDER}?roles=${roles}`, body)
      .then((res) => {
        context.setBackDropOpen(false);
        if (res.Is_Success) {
          context.setDashBoardBody({
            page: 0,
            dataLength: 0,
            hasMore: true,
            pageSize: 10,
          });
          context.setDashboardData({});
          setPlacedData({ ...placedData, data: [] });
          // context.setPlacedOrders({});
          // context.setApprovedOrders({});
          // context.setLoadedOrders({});
          // context.setRejectedOrders({});
          NotificationManager.success(res.Message, "", 3000);
          context.setOrderJSON({
            ...orderObject,
          });

          if (location.pathname.includes(routeConstant.CREATE_ORDER_MAIN)) {
            context.setModalOpen(true);
          }
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch((err) => {
        context.setBackDropOpen(false);
        console.error(err);
        if (err.response) {
          NotificationManager.error(
            err.response.data.ExceptionMessage,
            "",
            3000
          );
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };

  return (
    <LayoutCreateOrder onNextHandler={onNextHandler} title="Create Order">
      <div className="_orderConfirm">
        <div className="container-fluid">
          <div className="col-12 _orderConfirmDetails">
            <h5>Order Specifics</h5>
            <div className="row">
              <div className="col-12">
                <table>
                  <tbody>
                    <tr>
                      <th>Order Number</th>
                      <th>:</th>
                      <td
                        title={
                          context.orderJSON.OrderHeader.SplitNumber == "0"
                            ? `${context.orderJSON.OrderHeader.OrderNumber}`
                            : `${context.orderJSON.OrderHeader.OrderNumber}/${context.orderJSON.OrderHeader.SplitNumber}`
                        }
                      >
                        {context.orderJSON.OrderHeader.OrderNumber}
                        {context.orderJSON.OrderHeader.SplitNumber !== "0"
                          ? `/${context.orderJSON.OrderHeader.SplitNumber}`
                          : ""}
                      </td>

                      <th>Order Date</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderDate ===
                        "1900-01-01 00:00:00.000"
                          ? ""
                          : context.orderJSON.OrderHeader.OrderDate
                          ? moment(
                              context.orderJSON.OrderHeader.OrderDate
                            ).format("MM-DD-YYYY")
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <th>CW1 Order Number</th>
                      <th>:</th>
                      <td></td>
                      <th>Order Status</th>
                      <th>:</th>
                      <td>{context.orderJSON.OrderHeader.OrderStatus}</td>
                    </tr>
                    <tr>
                      <th>Sending Agent</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderSendingAgentCode ??
                          ""}
                      </td>
                      <th>Receiving Agent</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader
                          .OrderReceivingAgentCode ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Supplier Name</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderSupplierCode ?? ""}
                      </td>
                      <th>Supplier Address</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderSupplierAddress1 ??
                          ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Buyer Name</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderBuyerCode ?? ""}
                      </td>
                      <th>Buyer Address</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderBuyerAddress1 ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Final Delivery Location</th>

                      <th>:</th>

                      <td>
                        {context.orderJSON.OrderHeader
                          .OrderBuyerDeliveryAddress1 ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Currency of Payment</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderCurrencyCode ?? ""}
                      </td>
                      <th>INCO Terms</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderIncoTerm ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Container Mode</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderContainerMode ?? ""}
                      </td>
                      <th>Transport Mode</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderTransportMode ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Req. Ex. Works</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader
                          .OrderExWorksRequiredBy === "1900-01-01 00:00:00.000"
                          ? ""
                          : context.orderJSON.OrderHeader.OrderExWorksRequiredBy
                          ? moment(
                              context.orderJSON.OrderHeader
                                .OrderExWorksRequiredBy
                            ).format("MM-DD-YYYY")
                          : ""}
                      </td>
                      <th>Req. In Store</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader
                          .OrderDeliveryRequiredBy === "1900-01-01 00:00:00.000"
                          ? ""
                          : context.orderJSON.OrderHeader
                              .OrderDeliveryRequiredBy
                          ? moment(
                              context.orderJSON.OrderHeader
                                .OrderDeliveryRequiredBy
                            ).format("MM-DD-YYYY")
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Service Level</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderServiceLevelcode}
                      </td>
                      <th>Shipment No.</th>
                      <th>:</th>
                      <td>{context.orderJSON.OrderHeader.OrderPreAdviceId}</td>
                    </tr>
                    <tr>
                      <th>Invoice No.</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderInvoiceNumber}
                      </td>
                      <th>Origin Country</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderCountryOfOrigin}
                      </td>
                    </tr>
                    <tr>
                      <th>Goods Description</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderGoodsDescription}
                      </td>
                      <th>Special Instructions</th>
                      <th>:</th>
                      <td>
                        {context.orderJSON.OrderHeader.OrderSpecialInstruction}
                      </td>
                    </tr>
                    <tr>
                    <th>Pickup from Origin Factory</th>
                      <th>:</th>
                      <td>
                      {context.orderJSON.OrderHeader
                            .PickupfromOriginFactory ===
                          "1900-01-01 00:00:00.000"
                            ? ""
                            : context.orderJSON.OrderHeader
                                .PickupfromOriginFactory
                            ? moment(
                              context.orderJSON.OrderHeader
                                  .PickupfromOriginFactory
                              ).format("MM-DD-YYYY")
                            : ""}
                       
                          {/* {context.orderJSON.OrderMilstonesCollection[2]?.MilstoneEstimatedDatey === "1900-01-01 00:00:00.000"
                          ? ""
                          : context.orderJSON.OrderMilstonesCollection[2]?.MilstoneEstimatedDate
                          ? moment(
                              context.orderJSON.OrderMilstonesCollection[2]?.MilstoneEstimatedDate
                            ).format("MM-DD-YYYY")
                          : ""} */}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal msg="Your order has been Succesfully created." />
    </LayoutCreateOrder>
  );
}

export default Confirmation;
